import React from 'react';
import { Tooltip, Typography } from "antd";
import { Application, resource } from "@yulintu/freesia-bootstrap";

export default function AppGalleryGalleryItem(props) {

    props.data.description = props.data.description || "暂无描述";
    let showDescription = props.data.showDescription || props.showDescription;
    if (showDescription === undefined)
        showDescription = true;

    return (
        <Tooltip title={props.data.description || props.data.summary} placement='bottom'>
            <div className="layout-h center app-gallery-item--gallery-item" style={{ width: props.data.width || 480 }}>
                <div className="logo" style={{ alignItems: showDescription ? "flex-start" : "center" }}>
                    {
                        props.data.logoSvg ? (
                            <Application.SvgIcon type={props.data.logoSmSvg || props.data.logoSvg} style={props.data.logoSmSvgStyle || props.data.logoSvgStyle} />
                        ) : (
                            <img className="image" src={resource(props.data.logoSmImage || props.data.logoImage)} style={props.data.logoSmImageStyle || props.data.logoImageStyle} />
                        )
                    }
                </div>
                <div className="fill layout-v w0 content" style={{ justifyContent: showDescription ? "flex-start" : "center" }}>
                    <div className="title text-nowrap text-ellipsis">{props.data.title || props.data.alias}</div>
                    {
                        showDescription && <Typography.Paragraph className="fill h0 description second-text text-wrap" title={props.data.summary || props.data.description} ellipsis={{ rows: 2, expandable: false }}>
                            {props.data.summary || props.data.description}
                        </Typography.Paragraph>
                    }
                </div>
            </div >
        </Tooltip>
    );
}